module.exports = __webpack_public_path__ + "img/imgMemberM.0de21840.svg";